<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="true" placeholder="Select">
    <el-option value="Cost Reduction">
      Cost Reduction
    </el-option>
    <el-option value="Growth">
      Growth
    </el-option>
    <el-option value="Maintenance">
      Maintenance
    </el-option>
    <el-option value="Regulatory Compliance">
      Regulatory Compliance
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      statusList: Array
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
